import {getLocalUser} from 'constants/selectors';
import React from 'react';
import Avatar from 'react-avatar';
import {useSelector} from 'react-redux';

function Icon() {
  const user = useSelector(getLocalUser);
  return (
    <Avatar name={`${user.first_name} ${user.last_name}`} email={user.email} size="57" round={true} maxInitials={2} />
  );
}

export default Icon;
